import React from "react";

import Box from "@mui/material/Box";
import { CssBaseline } from "@mui/material";

import Project from "../modules/Project";

export default function ProjectPage() {
  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <Project />
    </Box>
  );
}
